/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import './api';
import '../bizbank/service';
import '../beemo/v2/reporting/settlements';
import './model';
import '../banking/common';
import '../common/time';
import '../banking/account_model';
import '../instant-deposit/instant_deposits';
import '../simple_instrument_store/model';
import '../bills/tender';
import '../bizbank/unified_activity';
import '../protobuf/rpc/rpc';
import '../ledger/deposit_settings';
import '../instant-deposit/dashboard_service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "deposits": {
        "nested": {
          "service": {
            "nested": {
              "GetBalanceSummaryRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeRecentActivity": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "applyFeeRateToWithdrawalAmount": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "GetBalanceSummaryResponse": {
                "fields": {
                  "balance": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instantDepositDetails": {
                    "type": ".squareup.deposits.service.InstantDepositDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkedBankAccount": {
                    "type": ".squareup.deposits.BankAccountInfo",
                    "id": 9,
                    "rule": "optional"
                  },
                  "linkedCard": {
                    "type": ".squareup.deposits.service.CardInfo",
                    "id": 4,
                    "rule": "optional"
                  },
                  "squareCard": {
                    "type": ".squareup.bizbank.service.CardData",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "allowPartialDeposit": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardActivity": {
                    "type": ".squareup.bizbank.service.CardActivity",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "depositActivity": {
                    "type": ".squareup.deposits.service.GetBalanceSummaryResponse.DepositActivity",
                    "id": 8,
                    "rule": "optional"
                  },
                  "eligibilityDetails": {
                    "type": ".squareup.deposits.service.EligibilityDetails",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "balanceInformation": {
                    "type": ".squareup.deposits.service.GetBalanceSummaryResponse.BalanceInformation",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DepositActivity": {
                    "fields": {
                      "activeSalesReport": {
                        "type": ".squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                        "id": 1,
                        "rule": "optional"
                      },
                      "pendingDeposit": {
                        "type": ".squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "BalanceInformation": {
                    "fields": {
                      "totalBalance": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "availableBalance": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "pendingBalance": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "balanceType": {
                        "type": ".squareup.deposits.BalanceType",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetBalanceStatusRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceStatusResponse": {
                "fields": {
                  "viewCapability": {
                    "type": ".squareup.deposits.service.GetBalanceStatusResponse.ViewCapability",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "eligibleBalanceActivity": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ViewCapability": {
                    "values": {
                      "UNKNOWN_VIEW_CAPABILITY_DO_NOT_USE": 0,
                      "UNIFIED_ACTIVITY": 1,
                      "CARD_UPSELL": 2,
                      "CARD_SPEND_REPORT": 3,
                      "DIRECT_DEPOSIT_ACCOUNT": 4,
                      "SPEND_VISUALIZATION": 5
                    }
                  }
                }
              },
              "ListBalancesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListBalancesResponse": {
                "fields": {
                  "balanceSummaries": {
                    "type": ".squareup.deposits.service.ListBalancesResponse.BalanceSummary",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BalanceSummary": {
                    "fields": {
                      "balanceId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "balanceType": {
                        "type": ".squareup.deposits.BalanceType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "availableBalance": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.banking.AccountState",
                        "id": 5,
                        "rule": "optional"
                      },
                      "supportedBalanceActivities": {
                        "type": ".squareup.deposits.BalanceActivityType",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "supportedBalanceTransferDestinationTypes": {
                        "type": ".squareup.deposits.BalanceType",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "pendingSettlementTime": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 8,
                        "rule": "optional"
                      },
                      "balanceOwnershipToken": {
                        "type": ".squareup.deposits.BalanceOwnershipToken",
                        "id": 9,
                        "rule": "optional"
                      },
                      "accountMetadata": {
                        "type": ".squareup.banking.AccountMetadata",
                        "id": 10,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetEligibleInstrumentsRequest": {
                "fields": {
                  "activityType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EligibleInstrumentsForActivity": {
                "fields": {
                  "activityType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instrument": {
                    "type": ".squareup.deposits.InstrumentView",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "availableAction": {
                    "type": ".squareup.deposits.service.EligibleInstrumentsForActivity.AvailableInstrumentAction",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "eligibleInstrumentActionState": {
                    "type": ".squareup.deposits.service.EligibleInstrumentsForActivity.EligibleInstrumentActionState",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AvailableInstrumentAction": {
                    "values": {
                      "UNKNOWN_AVAILABLE_ACTION_DO_NOT_USE": 0,
                      "LINK_BANK_ACCOUNT": 1,
                      "LINK_DEBIT_CARD": 2,
                      "RESEND_CONFIRMATION_MESSAGE": 3,
                      "CANCEL_VERIFICATION": 4
                    }
                  },
                  "EligibleInstrumentActionState": {
                    "values": {
                      "UNKNOWN_ELIGIBLE_ACTION_STATE_DO_NOT_USE": 0,
                      "ELIGIBLE": 1,
                      "ACTION_REQUIRED": 2,
                      "UNSUPPORTED": 3
                    }
                  }
                }
              },
              "GetEligibleInstrumentsResponse": {
                "fields": {
                  "eligibleInstrumentsForActivity": {
                    "type": ".squareup.deposits.service.EligibleInstrumentsForActivity",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "EligibilityDetails": {
                "fields": {
                  "activityType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "blocker": {
                    "type": ".squareup.deposits.EligibilityBlocker",
                    "id": 2,
                    "rule": "optional"
                  },
                  "minAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "maxAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "eligibilityStatus": {
                    "type": ".squareup.deposits.LocalizedStatusMessage",
                    "id": 6,
                    "rule": "optional"
                  },
                  "primaryInstrument": {
                    "type": ".squareup.deposits.InstrumentView",
                    "id": 7,
                    "rule": "optional"
                  },
                  "primaryInstrumentChanged": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "fee": {
                    "type": ".squareup.ledger.service.FeeStructure",
                    "id": 9,
                    "rule": "optional"
                  },
                  "staticDailyLimit": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "InstantDepositDetails": {
                "fields": {
                  "eligibilityBlocker": {
                    "type": ".squareup.ledger.service.EligibilityBlocker",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxDepositAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "showPriceChangeModal": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "showInstrumentChangedScreen": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "primaryInstrument": {
                    "type": ".squareup.simple_instrument_store.Instrument.Type",
                    "id": 6,
                    "rule": "optional"
                  },
                  "maxDepositFeeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "CardInfo": {
                "fields": {
                  "brand": {
                    "type": ".squareup.bills.CardTender.Card.Brand",
                    "id": 1,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "supportsInstantDeposit": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CreateTransferRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balanceActivityType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 5,
                    "rule": "optional"
                  },
                  "destination": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 6,
                    "rule": "optional"
                  },
                  "clientIp": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": ".squareup.deposits.TransferMetadata",
                    "id": 9,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isWithdrawalFromBalanceAmount": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "applyFeeRateToWithdrawalAmount": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "CreateTransferResponse": {
                "fields": {
                  "statusMessage": {
                    "type": ".squareup.deposits.LocalizedStatusMessage",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balanceActivity": {
                    "type": ".squareup.deposits.BalanceActivity",
                    "id": 1
                  },
                  "failure": {
                    "type": ".squareup.deposits.BalanceActivityFailure",
                    "id": 2
                  }
                },
                "nested": {
                  "result": {
                    "oneof": ["balanceActivity", "failure"]
                  }
                }
              },
              "GetEligibilityDetailsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activityType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "GetEligibilityDetailsResponse": {
                "fields": {
                  "eligibilityDetails": {
                    "type": ".squareup.deposits.service.EligibilityDetails",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetMerchantTransferTagsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetMerchantTransferTagsResponse": {
                "fields": {
                  "unitTransferTags": {
                    "type": ".squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse",
                    "id": 1,
                    "keyType": "string"
                  }
                },
                "nested": {
                  "TransferTagsResponse": {
                    "fields": {
                      "transferTag": {
                        "type": "string",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "INVALID_UNIT_TOKEN": 1,
                          "UNKNOWN_ERROR": 2
                        }
                      },
                      "result": {
                        "oneof": ["transferTag", "error"]
                      }
                    }
                  }
                }
              },
              "SetMerchantTransferTagsRequest": {
                "fields": {
                  "merchantAndTransferTag": {
                    "type": ".squareup.deposits.service.SetMerchantTransferTagsRequest.MerchantAndTransferTag",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "MerchantAndTransferTag": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transferTag": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SetMerchantTransferTagsResponse": {
                "fields": {
                  "setTransferTagFailure": {
                    "type": ".squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "SetTransferTagFailure": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "error": {
                        "type": ".squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure.Error",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "CONTAINS_DISALLOWED_CHAR": 1,
                          "CONTAINS_PROFANITY": 2,
                          "TOO_LONG": 3,
                          "UNKNOWN_ERROR": 4
                        }
                      }
                    }
                  }
                }
              },
              "CreateCheckDepositRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "checkImages": {
                    "type": ".squareup.deposits.service.CreateCheckDepositRequest.CheckImages",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clientIp": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": ".squareup.deposits.service.CreateCheckDepositRequest.CheckDepositMetadata",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CheckDepositMetadata": {
                    "fields": {
                      "invoiceToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CheckImages": {
                    "fields": {
                      "front": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "back": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CreateCheckDepositResponse": {
                "fields": {
                  "statusMessage": {
                    "type": ".squareup.deposits.LocalizedStatusMessage",
                    "id": 4,
                    "rule": "optional"
                  },
                  "balanceActivity": {
                    "type": ".squareup.deposits.BalanceActivity",
                    "id": 2
                  },
                  "failure": {
                    "type": ".squareup.deposits.BalanceActivityFailure",
                    "id": 3
                  }
                },
                "nested": {
                  "result": {
                    "oneof": ["balanceActivity", "failure"]
                  }
                }
              },
              "GetPendingActivitiesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetPendingActivitiesResponse": {
                "fields": {
                  "pendingActivities": {
                    "type": ".squareup.deposits.service.GetPendingActivitiesResponse.PendingActivities",
                    "id": 1,
                    "keyType": "string"
                  }
                },
                "nested": {
                  "PendingActivities": {
                    "fields": {
                      "activities": {
                        "type": ".squareup.deposits.service.GetPendingActivitiesResponse.PendingActivity",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "PendingActivity": {
                    "fields": {
                      "amount": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "occurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "activityState": {
                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                        "id": 6,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "balanceActivityType": {
                        "type": ".squareup.deposits.BalanceActivityType",
                        "id": 4
                      },
                      "activityType": {
                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                        "id": 5
                      }
                    },
                    "nested": {
                      "type": {
                        "oneof": ["balanceActivityType", "activityType"]
                      }
                    }
                  }
                }
              },
              "ExternalListCounterpartTransferEntitiesRequest": {
                "fields": {
                  "sourceId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 1
                  },
                  "destinationId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2
                  }
                },
                "nested": {
                  "id": {
                    "oneof": ["sourceId", "destinationId"]
                  }
                }
              },
              "ListCounterpartTransferEntitiesResponse": {
                "fields": {
                  "balanceGroup": {
                    "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup",
                    "id": 3,
                    "rule": "optional"
                  },
                  "bankAccountGroup": {
                    "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cardGroup": {
                    "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sourceId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 1
                  },
                  "destinationId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2
                  },
                  "sourceEntity": {
                    "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntity",
                    "id": 6
                  },
                  "destinationEntity": {
                    "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntity",
                    "id": 7
                  }
                },
                "nested": {
                  "TransferEntity": {
                    "fields": {
                      "balance": {
                        "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity",
                        "id": 1
                      },
                      "bankAccount": {
                        "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup.TransferBankAccountEntity",
                        "id": 2
                      },
                      "card": {
                        "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup.TransferCardEntity",
                        "id": 3
                      }
                    },
                    "nested": {
                      "entity": {
                        "oneof": ["balance", "bankAccount", "card"]
                      }
                    }
                  },
                  "TransferEntityGroup": {
                    "fields": {
                      "error": {
                        "type": ".squareup.protobuf.rpc.ResponseCode",
                        "id": 1,
                        "rule": "optional"
                      },
                      "balances": {
                        "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup",
                        "id": 2
                      },
                      "bankAccounts": {
                        "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup",
                        "id": 3
                      },
                      "cards": {
                        "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup",
                        "id": 4
                      }
                    },
                    "nested": {
                      "TransferBalanceEntityGroup": {
                        "fields": {
                          "data": {
                            "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "TransferBalanceEntity": {
                            "fields": {
                              "balanceId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "availableBalance": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "balanceType": {
                                "type": ".squareup.deposits.service.TransferEntityType",
                                "id": 3,
                                "rule": "optional"
                              },
                              "balanceName": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "isFrozen": {
                                "type": "bool",
                                "id": 5,
                                "rule": "optional"
                              },
                              "authorityToken": {
                                "type": ".squareup.deposits.AuthorityToken",
                                "id": 6,
                                "rule": "optional"
                              },
                              "category": {
                                "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity.TransferBalanceEntityCategory",
                                "id": 7,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "TransferBalanceEntityCategory": {
                                "values": {
                                  "UNKNOWN_BALANCE_CATEGORY_DO_NOT_USE": 0,
                                  "UNKNOWN": 1,
                                  "GENERAL_SAVINGS": 2,
                                  "CUSTOM": 3,
                                  "TAX": 4,
                                  "RAINY_DAY": 5,
                                  "RENT": 6,
                                  "PAYROLL": 7,
                                  "LOCATION_BALANCE": 8
                                }
                              }
                            }
                          }
                        }
                      },
                      "TransferBankAccountEntityGroup": {
                        "fields": {
                          "data": {
                            "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup.TransferBankAccountEntity",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "TransferBankAccountEntity": {
                            "fields": {
                              "instrumentToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "accountNumberSuffix": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "bankName": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "createdAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 4,
                                "rule": "optional"
                              },
                              "updatedAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 5,
                                "rule": "optional"
                              },
                              "verificationStatus": {
                                "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityVerificationState",
                                "id": 6,
                                "rule": "optional"
                              },
                              "supportsInstantDeposit": {
                                "type": "bool",
                                "id": 7,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              },
                              "nickname": {
                                "type": "string",
                                "id": 8,
                                "rule": "optional"
                              },
                              "encodedSqwebBankToken": {
                                "type": "string",
                                "id": 9,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "TransferCardEntityGroup": {
                        "fields": {
                          "data": {
                            "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup.TransferCardEntity",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "TransferCardEntity": {
                            "fields": {
                              "instrumentToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "panSuffix": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "cardBrand": {
                                "type": ".squareup.simple_instrument_store.Brand",
                                "id": 3,
                                "rule": "optional"
                              },
                              "createdAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 4,
                                "rule": "optional"
                              },
                              "updatedAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 5,
                                "rule": "optional"
                              },
                              "verificationStatus": {
                                "type": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityVerificationState",
                                "id": 6,
                                "rule": "optional"
                              },
                              "isFrozen": {
                                "type": "bool",
                                "id": 7,
                                "rule": "optional"
                              },
                              "nickname": {
                                "type": "string",
                                "id": 8,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "transfer_entity_group": {
                        "oneof": ["balances", "bankAccounts", "cards"]
                      }
                    }
                  },
                  "TransferEntityVerificationState": {
                    "values": {
                      "TRANSFER_ENTITY_VERIFICATION_STATE_DO_NOT_USE": 0,
                      "VERIFIED": 1,
                      "PENDING_VERIFICATION": 2,
                      "AWAITING_2FA_CONFIRMATION": 3,
                      "FAILED": 4,
                      "CANCELLED": 5,
                      "EXPIRED_2FA_CONFIRMATION": 6
                    }
                  },
                  "id": {
                    "oneof": ["sourceId", "destinationId"]
                  },
                  "entity": {
                    "oneof": ["sourceEntity", "destinationEntity"]
                  }
                }
              },
              "GetTransferFeeDetailsRequest": {
                "fields": {
                  "sourceId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "destinationId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "withdrawalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GetTransferFeeDetailsResponse": {
                "fields": {
                  "sourceId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "destinationId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "withdrawalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transferAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "feeBasisPoints": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "TransferEntityType": {
                "values": {
                  "UNKNOWN_TRANSFER_ENTITY_DO_NOT_USE": 0,
                  "SAVINGS_FOLDER": 1,
                  "CHECKING_BALANCE": 2,
                  "MANUAL_STORED_BALANCE": 3,
                  "AUTOMATIC_BALANCE": 4,
                  "BANK_ACCOUNT": 5,
                  "CARD": 6,
                  "SAVINGS_BANK_ACCOUNT": 7,
                  "CHECK": 8
                }
              },
              "ListTransferInstrumentOutagesRequest": {
                "fields": {
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": ".squareup.deposits.service.ListTransferInstrumentOutagesRequest.TransferType",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "outageStartTimeMin": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "outageStartTimeMax": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TransferType": {
                    "values": {
                      "UNKNOWN_TRANSFER_TYPE_DO_NOT_USE": 0,
                      "INSTANT_PAYOUT": 1,
                      "SAME_DAY_PAYOUT": 2
                    }
                  }
                }
              },
              "ListTransferInstrumentOutagesResponse": {
                "fields": {
                  "instrumentOutageInformation": {
                    "type": ".squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "InstrumentOutageInformation": {
                    "fields": {
                      "activityType": {
                        "type": ".squareup.deposits.BalanceActivityType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "instrumentOutage": {
                        "type": ".squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "InstrumentOutage": {
                        "fields": {
                          "instrumentToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "institutionName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "outageType": {
                            "type": ".squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "outageRadius": {
                            "type": ".squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageRadius",
                            "id": 4,
                            "rule": "optional"
                          },
                          "startTime": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 5,
                            "rule": "optional"
                          },
                          "endTime": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 6,
                            "rule": "optional"
                          },
                          "outageCategory": {
                            "type": ".squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageCategory",
                            "id": 7,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "OutageType": {
                            "values": {
                              "UNKNOWN_OUTAGE_TYPE_DO_NOT_USE": 0,
                              "ACTIVE": 1,
                              "SCHEDULED": 2
                            }
                          },
                          "OutageRadius": {
                            "values": {
                              "UNKNOWN_OUTAGE_RADIUS_DO_NOT_USE": 0,
                              "RECEIVING_BANK": 1,
                              "BANKING_RAILS": 2,
                              "INTERNAL": 3
                            }
                          },
                          "OutageCategory": {
                            "values": {
                              "UNKNOWN_OUTAGE_CATEGORY_DO_NOT_USE": 0,
                              "PLANNED": 1,
                              "UNPLANNED": 2,
                              "RECURRING": 3
                            }
                          }
                        }
                      }
                    }
                  }
                }
              },
              "TransferInstrument": {
                "fields": {
                  "instrumentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "availableActions": {
                    "type": ".squareup.deposits.AvailableInstrumentAction",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "supportedBalanceActivityTypes": {
                    "type": ".squareup.deposits.BalanceActivityType",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "bankAccountEntity": {
                    "type": ".squareup.deposits.TransferBankAccountEntity",
                    "id": 2
                  },
                  "cardEntity": {
                    "type": ".squareup.deposits.TransferCardEntity",
                    "id": 3
                  }
                },
                "nested": {
                  "instrument_summary": {
                    "oneof": ["bankAccountEntity", "cardEntity"]
                  }
                }
              },
              "ExternalListTransferInstrumentsWithPriorityRequest": {
                "fields": {
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ExternalListTransferInstrumentsWithPriorityResponse": {
                "fields": {
                  "transferInstruments": {
                    "type": ".squareup.deposits.service.TransferInstrumentWithPriority",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "bankAccountGroup": {
                    "type": ".squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityResponse.BankAccountGroup",
                    "id": 2,
                    "rule": "optional"
                  },
                  "debitCardGroup": {
                    "type": ".squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityResponse.DebitCardGroup",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BankAccountGroup": {
                    "fields": {
                      "bankAccounts": {
                        "type": ".squareup.deposits.service.TransferInstrumentWithPriority",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "DebitCardGroup": {
                    "fields": {
                      "cards": {
                        "type": ".squareup.deposits.service.TransferInstrumentWithPriority",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "ExternalListTransferInstrumentActionsRequest": {
                "fields": {
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ExternalListTransferInstrumentActionsResponse": {
                "fields": {
                  "availableBankActions": {
                    "type": ".squareup.deposits.AvailableBankAction",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "availableCardActions": {
                    "type": ".squareup.deposits.AvailableCardAction",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "TransferInstrumentWithPriority": {
                "fields": {
                  "transferInstrument": {
                    "type": ".squareup.deposits.service.TransferInstrument",
                    "id": 1,
                    "rule": "optional"
                  },
                  "priority": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExternalRecurringTransferSchedule": {
                "fields": {
                  "scheduleId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sourceId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 3,
                    "rule": "optional"
                  },
                  "destinationId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 4,
                    "rule": "optional"
                  },
                  "amountConfiguration": {
                    "type": ".squareup.deposits.RecurringTransferAmountConfiguration",
                    "id": 5,
                    "rule": "optional"
                  },
                  "recurrenceRule": {
                    "type": ".squareup.deposits.RecurrenceRule",
                    "id": 6,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.deposits.ConfigurationStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 9,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "nextTransferDetails": {
                    "type": ".squareup.deposits.service.ScheduledTransferDetails",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "ScheduledTransferDetails": {
                "fields": {
                  "settlementTimeUtc": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "recurringTransferStatus": {
                    "type": ".squareup.deposits.RecurringTransferStatus",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExternalBulkListRecurringTransferSchedulesRequest": {
                "fields": {
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ExternalBulkListRecurringTransferSchedulesResponse": {
                "fields": {
                  "scheduleList": {
                    "type": ".squareup.deposits.service.ExternalRecurringTransferSchedule",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ExternalUpsertRecurringTransferScheduleRequest": {
                "fields": {
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 1,
                    "rule": "optional"
                  },
                  "destinationId": {
                    "type": ".squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountConfiguration": {
                    "type": ".squareup.deposits.RecurringTransferAmountConfiguration",
                    "id": 3,
                    "rule": "optional"
                  },
                  "recurrenceRule": {
                    "type": ".squareup.deposits.RecurrenceRule",
                    "id": 4,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.common.time.YearMonthDay",
                    "id": 5,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ExternalUpsertRecurringTransferScheduleResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse",
                    "id": 1
                  },
                  "success": {
                    "type": ".squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse.SuccessResponse",
                    "id": 2
                  }
                },
                "nested": {
                  "SuccessResponse": {
                    "fields": {
                      "schedule": {
                        "type": ".squareup.deposits.service.ExternalRecurringTransferSchedule",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ErrorResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "ERROR_DO_NOT_USE": 0,
                          "INVALID_REQUEST": 1,
                          "UNKNOWN_ERROR": 2,
                          "INVALID_DESTINATION_ID": 3
                        }
                      }
                    }
                  },
                  "result": {
                    "oneof": ["error", "success"]
                  }
                }
              },
              "ExternalUpdateRecurringTransferScheduleStatusRequest": {
                "fields": {
                  "scheduleId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.deposits.ConfigurationStatus",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExternalUpdateRecurringTransferScheduleStatusResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse",
                    "id": 1
                  },
                  "success": {
                    "type": ".squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse.SuccessResponse",
                    "id": 2
                  }
                },
                "nested": {
                  "SuccessResponse": {
                    "fields": {
                      "schedule": {
                        "type": ".squareup.deposits.service.ExternalRecurringTransferSchedule",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ErrorResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "ERROR_DO_NOT_USE": 0,
                          "INVALID_REQUEST": 1,
                          "UNKNOWN_ERROR": 2
                        }
                      }
                    }
                  },
                  "result": {
                    "oneof": ["error", "success"]
                  }
                }
              },
              "ExternalGetEarliestTransferScheduleStartDateRequest": {
                "fields": {
                  "authorityToken": {
                    "type": ".squareup.deposits.AuthorityToken",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ExternalGetEarliestTransferScheduleStartDateResponse": {
                "fields": {
                  "error": {
                    "type": ".squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse",
                    "id": 1
                  },
                  "success": {
                    "type": ".squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse.SuccessResponse",
                    "id": 2
                  }
                },
                "nested": {
                  "SuccessResponse": {
                    "fields": {
                      "nextStartDate": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 1,
                        "rule": "optional"
                      },
                      "timeZone": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ErrorResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "ERROR_DO_NOT_USE": 0,
                          "INVALID_REQUEST": 1,
                          "UNKNOWN_ERROR": 2
                        }
                      }
                    }
                  },
                  "result": {
                    "oneof": ["error", "success"]
                  }
                }
              },
              "ExternalDepositsService": {
                "methods": {
                  "GetDepositSchedule": {
                    "requestType": ".squareup.ledger.service.GetDepositScheduleRequest",
                    "responseType": ".squareup.ledger.service.GetDepositScheduleResponse"
                  },
                  "SetDepositSchedule": {
                    "requestType": ".squareup.ledger.service.SetDepositScheduleRequest",
                    "responseType": ".squareup.ledger.service.SetDepositScheduleResponse"
                  },
                  "GetBalanceStatus": {
                    "requestType": ".squareup.deposits.service.GetBalanceStatusRequest",
                    "responseType": ".squareup.deposits.service.GetBalanceStatusResponse"
                  },
                  "GetBalanceSummary": {
                    "requestType": ".squareup.deposits.service.GetBalanceSummaryRequest",
                    "responseType": ".squareup.deposits.service.GetBalanceSummaryResponse"
                  },
                  "GetEligibleInstruments": {
                    "requestType": ".squareup.deposits.service.GetEligibleInstrumentsRequest",
                    "responseType": ".squareup.deposits.service.GetEligibleInstrumentsResponse"
                  },
                  "GetInstantDepositSettlementDetail": {
                    "requestType": ".squareup.ledger.service.GetInstantDepositSettlementDetailRequest",
                    "responseType": ".squareup.ledger.service.GetInstantDepositSettlementDetailResponse"
                  },
                  "CreateTransfer": {
                    "requestType": ".squareup.deposits.service.CreateTransferRequest",
                    "responseType": ".squareup.deposits.service.CreateTransferResponse"
                  },
                  "GetEligibilityDetails": {
                    "requestType": ".squareup.deposits.service.GetEligibilityDetailsRequest",
                    "responseType": ".squareup.deposits.service.GetEligibilityDetailsResponse"
                  },
                  "EligibleForInstantDeposit": {
                    "requestType": ".squareup.ledger.service.EligibleForInstantDepositRequest",
                    "responseType": ".squareup.ledger.service.EligibleForInstantDepositResponse"
                  },
                  "GetMerchantTransferTags": {
                    "requestType": ".squareup.deposits.service.GetMerchantTransferTagsRequest",
                    "responseType": ".squareup.deposits.service.GetMerchantTransferTagsResponse"
                  },
                  "SetMerchantTransferTags": {
                    "requestType": ".squareup.deposits.service.SetMerchantTransferTagsRequest",
                    "responseType": ".squareup.deposits.service.SetMerchantTransferTagsResponse"
                  },
                  "GetPendingActivities": {
                    "requestType": ".squareup.deposits.service.GetPendingActivitiesRequest",
                    "responseType": ".squareup.deposits.service.GetPendingActivitiesResponse"
                  },
                  "ListBalances": {
                    "requestType": ".squareup.deposits.service.ListBalancesRequest",
                    "responseType": ".squareup.deposits.service.ListBalancesResponse"
                  },
                  "GetTransferFeeDetails": {
                    "requestType": ".squareup.deposits.service.GetTransferFeeDetailsRequest",
                    "responseType": ".squareup.deposits.service.GetTransferFeeDetailsResponse"
                  },
                  "ListCounterpartTransferEntities": {
                    "requestType": ".squareup.deposits.service.ExternalListCounterpartTransferEntitiesRequest",
                    "responseType": ".squareup.deposits.service.ListCounterpartTransferEntitiesResponse"
                  },
                  "ListTransferInstrumentsWithPriority": {
                    "requestType": ".squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityRequest",
                    "responseType": ".squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityResponse"
                  },
                  "ListTransferInstrumentActions": {
                    "requestType": ".squareup.deposits.service.ExternalListTransferInstrumentActionsRequest",
                    "responseType": ".squareup.deposits.service.ExternalListTransferInstrumentActionsResponse"
                  },
                  "UpsertRecurringTransferSchedule": {
                    "requestType": ".squareup.deposits.service.ExternalUpsertRecurringTransferScheduleRequest",
                    "responseType": ".squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse"
                  },
                  "UpdateRecurringTransferScheduleStatus": {
                    "requestType": ".squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusRequest",
                    "responseType": ".squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse"
                  },
                  "BulkListRecurringTransferSchedules": {
                    "requestType": ".squareup.deposits.service.ExternalBulkListRecurringTransferSchedulesRequest",
                    "responseType": ".squareup.deposits.service.ExternalBulkListRecurringTransferSchedulesResponse"
                  },
                  "GetEarliestTransferScheduleStartDate": {
                    "requestType": ".squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateRequest",
                    "responseType": ".squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse"
                  },
                  "ListTransferInstrumentOutages": {
                    "requestType": ".squareup.deposits.service.ListTransferInstrumentOutagesRequest",
                    "responseType": ".squareup.deposits.service.ListTransferInstrumentOutagesResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryResponse?.nested?.DepositActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryResponse?.nested?.BalanceInformation && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceStatusRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceStatusResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceStatusResponse?.nested?.ViewCapability && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListBalancesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListBalancesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListBalancesResponse?.nested?.BalanceSummary && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibleInstrumentsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibleInstrumentsForActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibleInstrumentsForActivity?.nested?.AvailableInstrumentAction && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibleInstrumentsForActivity?.nested?.EligibleInstrumentActionState && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibleInstrumentsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibilityDetails && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.InstantDepositDetails && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CardInfo && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateTransferRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateTransferResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibilityDetailsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibilityDetailsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsResponse?.nested?.TransferTagsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsResponse?.nested?.TransferTagsResponse?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsRequest?.nested?.MerchantAndTransferTag && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsResponse?.nested?.SetTransferTagFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsResponse?.nested?.SetTransferTagFailure?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateCheckDepositRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateCheckDepositRequest?.nested?.CheckDepositMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateCheckDepositRequest?.nested?.CheckImages && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateCheckDepositResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesResponse?.nested?.PendingActivities && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesResponse?.nested?.PendingActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListCounterpartTransferEntitiesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferBalanceEntityGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferBalanceEntityGroup?.nested?.TransferBalanceEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferBalanceEntityGroup?.nested?.TransferBalanceEntity?.nested?.TransferBalanceEntityCategory && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferBankAccountEntityGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferBankAccountEntityGroup?.nested?.TransferBankAccountEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferCardEntityGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityGroup?.nested?.TransferCardEntityGroup?.nested?.TransferCardEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListCounterpartTransferEntitiesResponse?.nested?.TransferEntityVerificationState && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetTransferFeeDetailsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetTransferFeeDetailsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.TransferEntityType && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesRequest?.nested?.TransferType && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesResponse?.nested?.InstrumentOutageInformation && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesResponse?.nested?.InstrumentOutageInformation?.nested?.InstrumentOutage && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesResponse?.nested?.InstrumentOutageInformation?.nested?.InstrumentOutage?.nested?.OutageType && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesResponse?.nested?.InstrumentOutageInformation?.nested?.InstrumentOutage?.nested?.OutageRadius && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListTransferInstrumentOutagesResponse?.nested?.InstrumentOutageInformation?.nested?.InstrumentOutage?.nested?.OutageCategory && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.TransferInstrument && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListTransferInstrumentsWithPriorityRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListTransferInstrumentsWithPriorityResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListTransferInstrumentsWithPriorityResponse?.nested?.BankAccountGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListTransferInstrumentsWithPriorityResponse?.nested?.DebitCardGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListTransferInstrumentActionsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalListTransferInstrumentActionsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.TransferInstrumentWithPriority && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalRecurringTransferSchedule && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ScheduledTransferDetails && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalBulkListRecurringTransferSchedulesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalBulkListRecurringTransferSchedulesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpsertRecurringTransferScheduleRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpsertRecurringTransferScheduleResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpsertRecurringTransferScheduleResponse?.nested?.SuccessResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpsertRecurringTransferScheduleResponse?.nested?.ErrorResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpsertRecurringTransferScheduleResponse?.nested?.ErrorResponse?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpdateRecurringTransferScheduleStatusRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpdateRecurringTransferScheduleStatusResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpdateRecurringTransferScheduleStatusResponse?.nested?.SuccessResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpdateRecurringTransferScheduleStatusResponse?.nested?.ErrorResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalUpdateRecurringTransferScheduleStatusResponse?.nested?.ErrorResponse?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalGetEarliestTransferScheduleStartDateRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalGetEarliestTransferScheduleStartDateResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalGetEarliestTransferScheduleStartDateResponse?.nested?.SuccessResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalGetEarliestTransferScheduleStartDateResponse?.nested?.ErrorResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalGetEarliestTransferScheduleStartDateResponse?.nested?.ErrorResponse?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalDepositsService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetBalanceSummaryRequest @ squareup/deposits/service.proto at 35:1
 */
export const GetBalanceSummaryRequest = $root.lookupType('squareup.deposits.service.GetBalanceSummaryRequest');
fixType(GetBalanceSummaryRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBalanceSummaryRequest);
/**
 * SOURCE GetBalanceSummaryResponse @ squareup/deposits/service.proto at 52:1
 */
export const GetBalanceSummaryResponse = $root.lookupType('squareup.deposits.service.GetBalanceSummaryResponse');
fixType(GetBalanceSummaryResponse, {
  balance: {
    required: true
  },
  instantDepositDetails: {
    required: true
  },
  allowPartialDeposit: {
    required: true
  },
  balanceInformation: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceSummaryResponse);
/**
 * SOURCE DepositActivity @ squareup/deposits/service.proto at 77:3
 */
GetBalanceSummaryResponse.DepositActivity = $root.lookupType('squareup.deposits.service.GetBalanceSummaryResponse.DepositActivity');
fixType(GetBalanceSummaryResponse.DepositActivity);
Builder.createAndAttachToType(GetBalanceSummaryResponse.DepositActivity);
/**
 * SOURCE BalanceInformation @ squareup/deposits/service.proto at 91:3
 */
GetBalanceSummaryResponse.BalanceInformation = $root.lookupType('squareup.deposits.service.GetBalanceSummaryResponse.BalanceInformation');
fixType(GetBalanceSummaryResponse.BalanceInformation, {
  totalBalance: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceSummaryResponse.BalanceInformation);
/**
 * SOURCE GetBalanceStatusRequest @ squareup/deposits/service.proto at 108:1
 */
export const GetBalanceStatusRequest = $root.lookupType('squareup.deposits.service.GetBalanceStatusRequest');
fixType(GetBalanceStatusRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBalanceStatusRequest);
/**
 * SOURCE GetBalanceStatusResponse @ squareup/deposits/service.proto at 112:1
 */
export const GetBalanceStatusResponse = $root.lookupType('squareup.deposits.service.GetBalanceStatusResponse');
fixType(GetBalanceStatusResponse);
Builder.createAndAttachToType(GetBalanceStatusResponse);
/**
 * SOURCE ViewCapability @ squareup/deposits/service.proto at 113:3
 */
GetBalanceStatusResponse.ViewCapability = $root.lookupEnum('squareup.deposits.service.GetBalanceStatusResponse.ViewCapability').values;
/**
 * SOURCE ListBalancesRequest @ squareup/deposits/service.proto at 159:1
 */
export const ListBalancesRequest = $root.lookupType('squareup.deposits.service.ListBalancesRequest');
fixType(ListBalancesRequest);
Builder.createAndAttachToType(ListBalancesRequest);
/**
 * SOURCE ListBalancesResponse @ squareup/deposits/service.proto at 164:1
 */
export const ListBalancesResponse = $root.lookupType('squareup.deposits.service.ListBalancesResponse');
fixType(ListBalancesResponse);
Builder.createAndAttachToType(ListBalancesResponse);
/**
 * Simplified generic view of a balance's current state.
 *
 * SOURCE BalanceSummary @ squareup/deposits/service.proto at 166:3
 */
ListBalancesResponse.BalanceSummary = $root.lookupType('squareup.deposits.service.ListBalancesResponse.BalanceSummary');
fixType(ListBalancesResponse.BalanceSummary);
Builder.createAndAttachToType(ListBalancesResponse.BalanceSummary);
/**
 * SOURCE GetEligibleInstrumentsRequest @ squareup/deposits/service.proto at 202:1
 */
export const GetEligibleInstrumentsRequest = $root.lookupType('squareup.deposits.service.GetEligibleInstrumentsRequest');
fixType(GetEligibleInstrumentsRequest, {
  activityType: {
    required: true
  },
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetEligibleInstrumentsRequest);
/**
 * SOURCE EligibleInstrumentsForActivity @ squareup/deposits/service.proto at 207:1
 */
export const EligibleInstrumentsForActivity = $root.lookupType('squareup.deposits.service.EligibleInstrumentsForActivity');
fixType(EligibleInstrumentsForActivity, {
  activityType: {
    required: true
  }
});
Builder.createAndAttachToType(EligibleInstrumentsForActivity);
/**
 * SOURCE AvailableInstrumentAction @ squareup/deposits/service.proto at 208:3
 */
EligibleInstrumentsForActivity.AvailableInstrumentAction = $root.lookupEnum('squareup.deposits.service.EligibleInstrumentsForActivity.AvailableInstrumentAction').values;
/**
 * SOURCE EligibleInstrumentActionState @ squareup/deposits/service.proto at 225:3
 */
EligibleInstrumentsForActivity.EligibleInstrumentActionState = $root.lookupEnum('squareup.deposits.service.EligibleInstrumentsForActivity.EligibleInstrumentActionState').values;
/**
 * SOURCE GetEligibleInstrumentsResponse @ squareup/deposits/service.proto at 256:1
 */
export const GetEligibleInstrumentsResponse = $root.lookupType('squareup.deposits.service.GetEligibleInstrumentsResponse');
fixType(GetEligibleInstrumentsResponse);
Builder.createAndAttachToType(GetEligibleInstrumentsResponse);
/**
 * SOURCE EligibilityDetails @ squareup/deposits/service.proto at 265:1
 */
export const EligibilityDetails = $root.lookupType('squareup.deposits.service.EligibilityDetails');
fixType(EligibilityDetails);
Builder.createAndAttachToType(EligibilityDetails);
/**
 * SOURCE InstantDepositDetails @ squareup/deposits/service.proto at 303:1
 */
export const InstantDepositDetails = $root.lookupType('squareup.deposits.service.InstantDepositDetails');
fixType(InstantDepositDetails);
Builder.createAndAttachToType(InstantDepositDetails);
/**
 * SOURCE CardInfo @ squareup/deposits/service.proto at 333:1
 */
export const CardInfo = $root.lookupType('squareup.deposits.service.CardInfo');
fixType(CardInfo, {
  brand: {
    required: true
  },
  panSuffix: {
    notEmpty: true
  },
  supportsInstantDeposit: {
    required: true
  }
});
Builder.createAndAttachToType(CardInfo);
/**
 * SOURCE CreateTransferRequest @ squareup/deposits/service.proto at 438:1
 */
export const CreateTransferRequest = $root.lookupType('squareup.deposits.service.CreateTransferRequest');
fixType(CreateTransferRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  amount: {
    required: true
  },
  balanceActivityType: {
    required: true
  }
});
Builder.createAndAttachToType(CreateTransferRequest);
/**
 * SOURCE CreateTransferResponse @ squareup/deposits/service.proto at 492:1
 */
export const CreateTransferResponse = $root.lookupType('squareup.deposits.service.CreateTransferResponse');
fixType(CreateTransferResponse);
Builder.createAndAttachToType(CreateTransferResponse);
/**
 * SOURCE GetEligibilityDetailsRequest @ squareup/deposits/service.proto at 635:1
 */
export const GetEligibilityDetailsRequest = $root.lookupType('squareup.deposits.service.GetEligibilityDetailsRequest');
fixType(GetEligibilityDetailsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetEligibilityDetailsRequest);
/**
 * SOURCE GetEligibilityDetailsResponse @ squareup/deposits/service.proto at 641:1
 */
export const GetEligibilityDetailsResponse = $root.lookupType('squareup.deposits.service.GetEligibilityDetailsResponse');
fixType(GetEligibilityDetailsResponse);
Builder.createAndAttachToType(GetEligibilityDetailsResponse);
/**
 * SOURCE GetMerchantTransferTagsRequest @ squareup/deposits/service.proto at 670:1
 */
export const GetMerchantTransferTagsRequest = $root.lookupType('squareup.deposits.service.GetMerchantTransferTagsRequest');
fixType(GetMerchantTransferTagsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetMerchantTransferTagsRequest);
/**
 * SOURCE GetMerchantTransferTagsResponse @ squareup/deposits/service.proto at 674:1
 */
export const GetMerchantTransferTagsResponse = $root.lookupType('squareup.deposits.service.GetMerchantTransferTagsResponse');
fixType(GetMerchantTransferTagsResponse);
Builder.createAndAttachToType(GetMerchantTransferTagsResponse);
/**
 * SOURCE TransferTagsResponse @ squareup/deposits/service.proto at 675:3
 */
GetMerchantTransferTagsResponse.TransferTagsResponse = $root.lookupType('squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse');
fixType(GetMerchantTransferTagsResponse.TransferTagsResponse);
Builder.createAndAttachToType(GetMerchantTransferTagsResponse.TransferTagsResponse);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 676:5
 */
GetMerchantTransferTagsResponse.TransferTagsResponse.Error = $root.lookupEnum('squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse.Error').values;
/**
 * SOURCE SetMerchantTransferTagsRequest @ squareup/deposits/service.proto at 690:1
 */
export const SetMerchantTransferTagsRequest = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsRequest');
fixType(SetMerchantTransferTagsRequest);
Builder.createAndAttachToType(SetMerchantTransferTagsRequest);
/**
 * SOURCE MerchantAndTransferTag @ squareup/deposits/service.proto at 691:3
 */
SetMerchantTransferTagsRequest.MerchantAndTransferTag = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsRequest.MerchantAndTransferTag');
fixType(SetMerchantTransferTagsRequest.MerchantAndTransferTag, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetMerchantTransferTagsRequest.MerchantAndTransferTag);
/**
 * SOURCE SetMerchantTransferTagsResponse @ squareup/deposits/service.proto at 699:1
 */
export const SetMerchantTransferTagsResponse = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsResponse');
fixType(SetMerchantTransferTagsResponse);
Builder.createAndAttachToType(SetMerchantTransferTagsResponse);
/**
 * SOURCE SetTransferTagFailure @ squareup/deposits/service.proto at 700:3
 */
SetMerchantTransferTagsResponse.SetTransferTagFailure = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure');
fixType(SetMerchantTransferTagsResponse.SetTransferTagFailure, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(SetMerchantTransferTagsResponse.SetTransferTagFailure);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 703:5
 */
SetMerchantTransferTagsResponse.SetTransferTagFailure.Error = $root.lookupEnum('squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure.Error').values;
/**
 * SOURCE CreateCheckDepositRequest @ squareup/deposits/service.proto at 717:1
 */
export const CreateCheckDepositRequest = $root.lookupType('squareup.deposits.service.CreateCheckDepositRequest');
fixType(CreateCheckDepositRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  },
  checkImages: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCheckDepositRequest);
/**
 * SOURCE CheckDepositMetadata @ squareup/deposits/service.proto at 718:3
 */
CreateCheckDepositRequest.CheckDepositMetadata = $root.lookupType('squareup.deposits.service.CreateCheckDepositRequest.CheckDepositMetadata');
fixType(CreateCheckDepositRequest.CheckDepositMetadata);
Builder.createAndAttachToType(CreateCheckDepositRequest.CheckDepositMetadata);
/**
 * SOURCE CheckImages @ squareup/deposits/service.proto at 727:3
 */
CreateCheckDepositRequest.CheckImages = $root.lookupType('squareup.deposits.service.CreateCheckDepositRequest.CheckImages');
fixType(CreateCheckDepositRequest.CheckImages, {
  front: {
    required: true
  },
  back: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCheckDepositRequest.CheckImages);
/**
 * SOURCE CreateCheckDepositResponse @ squareup/deposits/service.proto at 745:1
 */
export const CreateCheckDepositResponse = $root.lookupType('squareup.deposits.service.CreateCheckDepositResponse');
fixType(CreateCheckDepositResponse);
Builder.createAndAttachToType(CreateCheckDepositResponse);
/**
 * SOURCE GetPendingActivitiesRequest @ squareup/deposits/service.proto at 786:1
 */
export const GetPendingActivitiesRequest = $root.lookupType('squareup.deposits.service.GetPendingActivitiesRequest');
fixType(GetPendingActivitiesRequest);
Builder.createAndAttachToType(GetPendingActivitiesRequest);
/**
 * SOURCE GetPendingActivitiesResponse @ squareup/deposits/service.proto at 790:1
 */
export const GetPendingActivitiesResponse = $root.lookupType('squareup.deposits.service.GetPendingActivitiesResponse');
fixType(GetPendingActivitiesResponse);
Builder.createAndAttachToType(GetPendingActivitiesResponse);
/**
 * SOURCE PendingActivities @ squareup/deposits/service.proto at 791:3
 */
GetPendingActivitiesResponse.PendingActivities = $root.lookupType('squareup.deposits.service.GetPendingActivitiesResponse.PendingActivities');
fixType(GetPendingActivitiesResponse.PendingActivities);
Builder.createAndAttachToType(GetPendingActivitiesResponse.PendingActivities);
/**
 * SOURCE PendingActivity @ squareup/deposits/service.proto at 800:3
 */
GetPendingActivitiesResponse.PendingActivity = $root.lookupType('squareup.deposits.service.GetPendingActivitiesResponse.PendingActivity');
fixType(GetPendingActivitiesResponse.PendingActivity);
Builder.createAndAttachToType(GetPendingActivitiesResponse.PendingActivity);
/**
 * SOURCE ExternalListCounterpartTransferEntitiesRequest @ squareup/deposits/service.proto at 857:1
 */
export const ExternalListCounterpartTransferEntitiesRequest = $root.lookupType('squareup.deposits.service.ExternalListCounterpartTransferEntitiesRequest');
fixType(ExternalListCounterpartTransferEntitiesRequest);
Builder.createAndAttachToType(ExternalListCounterpartTransferEntitiesRequest);
/**
 * SOURCE ListCounterpartTransferEntitiesResponse @ squareup/deposits/service.proto at 873:1
 */
export const ListCounterpartTransferEntitiesResponse = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse');
fixType(ListCounterpartTransferEntitiesResponse);
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse);
/**
 * Next ID: 8
 *
 * SOURCE TransferEntity @ squareup/deposits/service.proto at 888:3
 */
ListCounterpartTransferEntitiesResponse.TransferEntity = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntity');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntity);
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntity);
/**
 * SOURCE TransferEntityGroup @ squareup/deposits/service.proto at 896:3
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup);
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup);
/**
 * SOURCE TransferBalanceEntityGroup @ squareup/deposits/service.proto at 904:5
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup);
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup);
/**
 * SOURCE TransferBalanceEntity @ squareup/deposits/service.proto at 907:7
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity, {
  balanceId: {
    notEmpty: true
  },
  availableBalance: {
    required: true
  },
  balanceType: {
    required: true
  },
  balanceName: {
    notEmpty: true
  },
  authorityToken: {
    required: true
  }
});
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity);
/**
 * SOURCE TransferBalanceEntityCategory @ squareup/deposits/service.proto at 916:9
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity.TransferBalanceEntityCategory = $root.lookupEnum('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBalanceEntityGroup.TransferBalanceEntity.TransferBalanceEntityCategory').values;
/**
 * SOURCE TransferBankAccountEntityGroup @ squareup/deposits/service.proto at 930:5
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup);
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup);
/**
 * SOURCE TransferBankAccountEntity @ squareup/deposits/service.proto at 933:7
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup.TransferBankAccountEntity = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup.TransferBankAccountEntity');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup.TransferBankAccountEntity, {
  instrumentToken: {
    notEmpty: true
  },
  accountNumberSuffix: {
    notEmpty: true
  },
  createdAt: {
    required: true
  },
  updatedAt: {
    required: true
  },
  verificationStatus: {
    required: true
  },
  encodedSqwebBankToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferBankAccountEntityGroup.TransferBankAccountEntity);
/**
 * SOURCE TransferCardEntityGroup @ squareup/deposits/service.proto at 949:5
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup);
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup);
/**
 * SOURCE TransferCardEntity @ squareup/deposits/service.proto at 952:7
 */
ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup.TransferCardEntity = $root.lookupType('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup.TransferCardEntity');
fixType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup.TransferCardEntity, {
  instrumentToken: {
    notEmpty: true
  },
  panSuffix: {
    notEmpty: true
  },
  cardBrand: {
    required: true
  },
  createdAt: {
    required: true
  },
  updatedAt: {
    required: true
  },
  verificationStatus: {
    required: true
  }
});
Builder.createAndAttachToType(ListCounterpartTransferEntitiesResponse.TransferEntityGroup.TransferCardEntityGroup.TransferCardEntity);
/**
 * SOURCE TransferEntityVerificationState @ squareup/deposits/service.proto at 965:3
 */
ListCounterpartTransferEntitiesResponse.TransferEntityVerificationState = $root.lookupEnum('squareup.deposits.service.ListCounterpartTransferEntitiesResponse.TransferEntityVerificationState').values;
/**
 * SOURCE GetTransferFeeDetailsRequest @ squareup/deposits/service.proto at 1048:1
 */
export const GetTransferFeeDetailsRequest = $root.lookupType('squareup.deposits.service.GetTransferFeeDetailsRequest');
fixType(GetTransferFeeDetailsRequest, {
  transferType: {
    required: true
  }
});
Builder.createAndAttachToType(GetTransferFeeDetailsRequest);
/**
 * SOURCE GetTransferFeeDetailsResponse @ squareup/deposits/service.proto at 1056:1
 */
export const GetTransferFeeDetailsResponse = $root.lookupType('squareup.deposits.service.GetTransferFeeDetailsResponse');
fixType(GetTransferFeeDetailsResponse, {
  transferType: {
    required: true
  },
  feeBasisPoints: {
    required: true
  }
});
Builder.createAndAttachToType(GetTransferFeeDetailsResponse);
/**
 * Represents viable sources and destinations that transfers can take part in
 *
 * SOURCE TransferEntityType @ squareup/deposits/service.proto at 1080:1
 */
export const TransferEntityType = $root.lookupEnum('squareup.deposits.service.TransferEntityType').values;
/**
 * SOURCE ListTransferInstrumentOutagesRequest @ squareup/deposits/service.proto at 1094:1
 */
export const ListTransferInstrumentOutagesRequest = $root.lookupType('squareup.deposits.service.ListTransferInstrumentOutagesRequest');
fixType(ListTransferInstrumentOutagesRequest, {
  authorityToken: {
    required: true
  },
  transferType: {
    required: true
  }
});
Builder.createAndAttachToType(ListTransferInstrumentOutagesRequest);
/**
 * SOURCE TransferType @ squareup/deposits/service.proto at 1100:3
 */
ListTransferInstrumentOutagesRequest.TransferType = $root.lookupEnum('squareup.deposits.service.ListTransferInstrumentOutagesRequest.TransferType').values;
/**
 * SOURCE ListTransferInstrumentOutagesResponse @ squareup/deposits/service.proto at 1107:1
 */
export const ListTransferInstrumentOutagesResponse = $root.lookupType('squareup.deposits.service.ListTransferInstrumentOutagesResponse');
fixType(ListTransferInstrumentOutagesResponse);
Builder.createAndAttachToType(ListTransferInstrumentOutagesResponse);
/**
 * SOURCE InstrumentOutageInformation @ squareup/deposits/service.proto at 1110:3
 */
ListTransferInstrumentOutagesResponse.InstrumentOutageInformation = $root.lookupType('squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation');
fixType(ListTransferInstrumentOutagesResponse.InstrumentOutageInformation, {
  activityType: {
    required: true
  }
});
Builder.createAndAttachToType(ListTransferInstrumentOutagesResponse.InstrumentOutageInformation);
/**
 * SOURCE InstrumentOutage @ squareup/deposits/service.proto at 1114:5
 */
ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage = $root.lookupType('squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage');
fixType(ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage, {
  instrumentToken: {
    required: true
  }
});
Builder.createAndAttachToType(ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage);
/**
 * Mapped from https://prototype.sqprod.co/#/docs/squareup.teller.bank_outages.Status
 * Indicates status of outage, whether it is currently ongoing or pending to occur later:
 * Status.PENDING -> OutageType.SCHEDULED
 * Status.ONGOING -> OutageType.ACTIVE
 *
 * SOURCE OutageType @ squareup/deposits/service.proto at 1129:7
 */
ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageType = $root.lookupEnum('squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageType').values;
/**
 * Mapped from https://prototype.sqprod.co/#/docs/squareup.teller.bank_outages.BlastRadius
 *
 * SOURCE OutageRadius @ squareup/deposits/service.proto at 1138:7
 */
ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageRadius = $root.lookupEnum('squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageRadius').values;
/**
 * Mapped from https://prototype.sqprod.co/#/docs/squareup.teller.bank_outages.OutageType
 * Indicates whether it is a scheduled, unscheduled, or recurring maintenance outage.
 *
 * SOURCE OutageCategory @ squareup/deposits/service.proto at 1149:7
 */
ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageCategory = $root.lookupEnum('squareup.deposits.service.ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageCategory').values;
/**
 * SOURCE TransferInstrument @ squareup/deposits/service.proto at 1184:1
 */
export const TransferInstrument = $root.lookupType('squareup.deposits.service.TransferInstrument');
fixType(TransferInstrument, {
  instrumentToken: {
    required: true
  }
});
Builder.createAndAttachToType(TransferInstrument);
/**
 * SOURCE ExternalListTransferInstrumentsWithPriorityRequest @ squareup/deposits/service.proto at 1194:1
 */
export const ExternalListTransferInstrumentsWithPriorityRequest = $root.lookupType('squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityRequest');
fixType(ExternalListTransferInstrumentsWithPriorityRequest, {
  authorityToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalListTransferInstrumentsWithPriorityRequest);
/**
 * SOURCE ExternalListTransferInstrumentsWithPriorityResponse @ squareup/deposits/service.proto at 1198:1
 */
export const ExternalListTransferInstrumentsWithPriorityResponse = $root.lookupType('squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityResponse');
fixType(ExternalListTransferInstrumentsWithPriorityResponse);
Builder.createAndAttachToType(ExternalListTransferInstrumentsWithPriorityResponse);
/**
 * SOURCE BankAccountGroup @ squareup/deposits/service.proto at 1199:3
 */
ExternalListTransferInstrumentsWithPriorityResponse.BankAccountGroup = $root.lookupType('squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityResponse.BankAccountGroup');
fixType(ExternalListTransferInstrumentsWithPriorityResponse.BankAccountGroup);
Builder.createAndAttachToType(ExternalListTransferInstrumentsWithPriorityResponse.BankAccountGroup);
/**
 * SOURCE DebitCardGroup @ squareup/deposits/service.proto at 1202:3
 */
ExternalListTransferInstrumentsWithPriorityResponse.DebitCardGroup = $root.lookupType('squareup.deposits.service.ExternalListTransferInstrumentsWithPriorityResponse.DebitCardGroup');
fixType(ExternalListTransferInstrumentsWithPriorityResponse.DebitCardGroup);
Builder.createAndAttachToType(ExternalListTransferInstrumentsWithPriorityResponse.DebitCardGroup);
/**
 * SOURCE ExternalListTransferInstrumentActionsRequest @ squareup/deposits/service.proto at 1210:1
 */
export const ExternalListTransferInstrumentActionsRequest = $root.lookupType('squareup.deposits.service.ExternalListTransferInstrumentActionsRequest');
fixType(ExternalListTransferInstrumentActionsRequest, {
  authorityToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalListTransferInstrumentActionsRequest);
/**
 * SOURCE ExternalListTransferInstrumentActionsResponse @ squareup/deposits/service.proto at 1214:1
 */
export const ExternalListTransferInstrumentActionsResponse = $root.lookupType('squareup.deposits.service.ExternalListTransferInstrumentActionsResponse');
fixType(ExternalListTransferInstrumentActionsResponse);
Builder.createAndAttachToType(ExternalListTransferInstrumentActionsResponse);
/**
 * SOURCE TransferInstrumentWithPriority @ squareup/deposits/service.proto at 1219:1
 */
export const TransferInstrumentWithPriority = $root.lookupType('squareup.deposits.service.TransferInstrumentWithPriority');
fixType(TransferInstrumentWithPriority);
Builder.createAndAttachToType(TransferInstrumentWithPriority);
/**
 * SOURCE ExternalRecurringTransferSchedule @ squareup/deposits/service.proto at 1226:1
 */
export const ExternalRecurringTransferSchedule = $root.lookupType('squareup.deposits.service.ExternalRecurringTransferSchedule');
fixType(ExternalRecurringTransferSchedule, {
  scheduleId: {
    notEmpty: true
  },
  authorityToken: {
    required: true
  },
  sourceId: {
    required: true
  },
  amountConfiguration: {
    required: true
  },
  recurrenceRule: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalRecurringTransferSchedule);
/**
 * SOURCE ScheduledTransferDetails @ squareup/deposits/service.proto at 1241:1
 */
export const ScheduledTransferDetails = $root.lookupType('squareup.deposits.service.ScheduledTransferDetails');
fixType(ScheduledTransferDetails);
Builder.createAndAttachToType(ScheduledTransferDetails);
/**
 * SOURCE ExternalBulkListRecurringTransferSchedulesRequest @ squareup/deposits/service.proto at 1246:1
 */
export const ExternalBulkListRecurringTransferSchedulesRequest = $root.lookupType('squareup.deposits.service.ExternalBulkListRecurringTransferSchedulesRequest');
fixType(ExternalBulkListRecurringTransferSchedulesRequest, {
  authorityToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalBulkListRecurringTransferSchedulesRequest);
/**
 * SOURCE ExternalBulkListRecurringTransferSchedulesResponse @ squareup/deposits/service.proto at 1250:1
 */
export const ExternalBulkListRecurringTransferSchedulesResponse = $root.lookupType('squareup.deposits.service.ExternalBulkListRecurringTransferSchedulesResponse');
fixType(ExternalBulkListRecurringTransferSchedulesResponse);
Builder.createAndAttachToType(ExternalBulkListRecurringTransferSchedulesResponse);
/**
 * SOURCE ExternalUpsertRecurringTransferScheduleRequest @ squareup/deposits/service.proto at 1254:1
 */
export const ExternalUpsertRecurringTransferScheduleRequest = $root.lookupType('squareup.deposits.service.ExternalUpsertRecurringTransferScheduleRequest');
fixType(ExternalUpsertRecurringTransferScheduleRequest, {
  authorityToken: {
    required: true
  },
  destinationId: {
    required: true
  },
  amountConfiguration: {
    required: true
  },
  recurrenceRule: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalUpsertRecurringTransferScheduleRequest);
/**
 * SOURCE ExternalUpsertRecurringTransferScheduleResponse @ squareup/deposits/service.proto at 1263:1
 */
export const ExternalUpsertRecurringTransferScheduleResponse = $root.lookupType('squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse');
fixType(ExternalUpsertRecurringTransferScheduleResponse);
Builder.createAndAttachToType(ExternalUpsertRecurringTransferScheduleResponse);
/**
 * SOURCE SuccessResponse @ squareup/deposits/service.proto at 1269:3
 */
ExternalUpsertRecurringTransferScheduleResponse.SuccessResponse = $root.lookupType('squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse.SuccessResponse');
fixType(ExternalUpsertRecurringTransferScheduleResponse.SuccessResponse, {
  schedule: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalUpsertRecurringTransferScheduleResponse.SuccessResponse);
/**
 * SOURCE ErrorResponse @ squareup/deposits/service.proto at 1273:3
 */
ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse = $root.lookupType('squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse');
fixType(ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse);
Builder.createAndAttachToType(ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 1276:5
 */
ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse.Error = $root.lookupEnum('squareup.deposits.service.ExternalUpsertRecurringTransferScheduleResponse.ErrorResponse.Error').values;
/**
 * SOURCE ExternalUpdateRecurringTransferScheduleStatusRequest @ squareup/deposits/service.proto at 1285:1
 */
export const ExternalUpdateRecurringTransferScheduleStatusRequest = $root.lookupType('squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusRequest');
fixType(ExternalUpdateRecurringTransferScheduleStatusRequest, {
  scheduleId: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalUpdateRecurringTransferScheduleStatusRequest);
/**
 * SOURCE ExternalUpdateRecurringTransferScheduleStatusResponse @ squareup/deposits/service.proto at 1290:1
 */
export const ExternalUpdateRecurringTransferScheduleStatusResponse = $root.lookupType('squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse');
fixType(ExternalUpdateRecurringTransferScheduleStatusResponse);
Builder.createAndAttachToType(ExternalUpdateRecurringTransferScheduleStatusResponse);
/**
 * SOURCE SuccessResponse @ squareup/deposits/service.proto at 1296:3
 */
ExternalUpdateRecurringTransferScheduleStatusResponse.SuccessResponse = $root.lookupType('squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse.SuccessResponse');
fixType(ExternalUpdateRecurringTransferScheduleStatusResponse.SuccessResponse, {
  schedule: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalUpdateRecurringTransferScheduleStatusResponse.SuccessResponse);
/**
 * SOURCE ErrorResponse @ squareup/deposits/service.proto at 1300:3
 */
ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse = $root.lookupType('squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse');
fixType(ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse);
Builder.createAndAttachToType(ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 1303:5
 */
ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse.Error = $root.lookupEnum('squareup.deposits.service.ExternalUpdateRecurringTransferScheduleStatusResponse.ErrorResponse.Error').values;
/**
 * SOURCE ExternalGetEarliestTransferScheduleStartDateRequest @ squareup/deposits/service.proto at 1311:1
 */
export const ExternalGetEarliestTransferScheduleStartDateRequest = $root.lookupType('squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateRequest');
fixType(ExternalGetEarliestTransferScheduleStartDateRequest, {
  authorityToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetEarliestTransferScheduleStartDateRequest);
/**
 * SOURCE ExternalGetEarliestTransferScheduleStartDateResponse @ squareup/deposits/service.proto at 1315:1
 */
export const ExternalGetEarliestTransferScheduleStartDateResponse = $root.lookupType('squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse');
fixType(ExternalGetEarliestTransferScheduleStartDateResponse);
Builder.createAndAttachToType(ExternalGetEarliestTransferScheduleStartDateResponse);
/**
 * SOURCE SuccessResponse @ squareup/deposits/service.proto at 1321:3
 */
ExternalGetEarliestTransferScheduleStartDateResponse.SuccessResponse = $root.lookupType('squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse.SuccessResponse');
fixType(ExternalGetEarliestTransferScheduleStartDateResponse.SuccessResponse, {
  nextStartDate: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetEarliestTransferScheduleStartDateResponse.SuccessResponse);
/**
 * SOURCE ErrorResponse @ squareup/deposits/service.proto at 1326:3
 */
ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse = $root.lookupType('squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse');
fixType(ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse);
Builder.createAndAttachToType(ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 1329:5
 */
ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse.Error = $root.lookupEnum('squareup.deposits.service.ExternalGetEarliestTransferScheduleStartDateResponse.ErrorResponse.Error').values;
/**
 * SOURCE ExternalDepositsService @ squareup/deposits/service.proto at 1598:1
 */
export const ExternalDepositsService = $root.lookupService('squareup.deposits.service.ExternalDepositsService');